<template>
  <div id="Navbar" class="container">
    <b-navbar toggleable type="dark" variant="dark">
      <b-navbar-brand>Expan</b-navbar-brand>

      <b-navbar-toggle target="navbar-toggle-collapse">
        <template v-slot:default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item>
            <router-link to="/expan-ussd-frontend/trips">Trips</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/expan-ussd-frontend/vehicles">Registered Vehicles</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/expan-ussd-frontend/vehicle">Add Vehicle</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/expan-ussd-frontend/driver">Add Driver</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/expan-ussd-frontend/passenger">Add Passenger</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="container" style="margin-top: 2rem">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style></style>
